import React, { useEffect, useState } from 'react'
import { Input, Button, message } from 'antd'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector, shallowEqual } from 'dva'
import { useRequest } from '@sisyphe/hooks'
import * as api from 'services/login'
import Footer from 'components/footer'
import './login.less'

const __dev__ = process.env.NODE_ENV === 'development'

const initialValues = {
  workId: __dev__ ? '15151551522' : '',
  code: __dev__ ? '123456' : '',
}

function validatePhoneNumber(phoneNumber) {
  const regex = /^1[3456789]\d{9}$/
  return regex.test(phoneNumber)
}

const defaultTimeCode = 60

const selector = ({ loading }) => ({
  loading: loading.effects['login/login'],
})
export default function Index() {
  const dispatch = useDispatch()
  const { loading } = useSelector(selector, shallowEqual)
  const history = useHistory()

  const [mobile, setMobile] = useState(initialValues.workId)
  const [captchaCode, setCaptchaCode] = useState(initialValues.code)
  const [hasCode, setHasCode] = useState(false)
  const [sendCode, setSendCode] = useState(false)
  const [timeCode, setTimeCode] = useState(defaultTimeCode)
  const [errorMsg] = useState('')

  // 用户发送短信验证码
  const { run: sendSmsUsing, loading: sendLoading } = useRequest(
    async () => {
      if (!validatePhoneNumber(mobile)) {
        message.warning('手机号不正确')
        return false
      }
      await api.sendSmsUsingPOST({
        captchaCode: 0,
        loginMobile: mobile,
        mobile: '',
      })
      setSendCode(true)
      setTimeCode(timeCode - 1)
      setHasCode(true)
      message.success('发送成功')
    },
    { manual: true }
  )

  // 登录
  const onLogin = async () => {
    await dispatch({
      type: 'login/login',
      payload: {
        loginMobile: mobile,
        captchaCode,
      },
    })
    message.success('登录成功')
    history.replace('/')
  }

  useEffect(() => {
    if (!sendCode) return
    const timer = setTimeout(() => {
      let time = timeCode - 1
      if (time === 0) {
        clearTimeout(timer)
        setTimeCode(defaultTimeCode)
        setSendCode(false)
      } else {
        setTimeCode(time)
      }
    }, 1000)
  }, [timeCode, sendCode])

  return (
    <div className="login">
      <div className="login-header">
        <img src={require('./logo.png')} className="header-logo" alt="" />
      </div>
      <div className="login-content">
        <img
          src={require('./background.png')}
          className="login-img-background"
          alt=""
        />
        <div className="login-content-warp">
          <div className="header-img-content">
            <p>欢迎来到西西弗企业采购平台</p>
            <img src={require('./content.png')} alt="" />
          </div>
          <div className="form-content">
            <p className="form-content-title">登录</p>
            <div>
              <Input
                value={mobile}
                placeholder="请输入手机号"
                className="form-content-iphone"
                onChange={e => setMobile(e.target.value?.replace(/\s/g, ''))}
              />
            </div>
            <div className="qr-code">
              <Input
                value={captchaCode}
                className="qr-code-input"
                placeholder="请输入验证码"
                maxLength={6}
                onChange={e =>
                  setCaptchaCode(e.target.value.replace(/[^0-9]/g, ''))
                }
              />
              <Button
                className="qr-code-button"
                type="link"
                disabled={
                  !validatePhoneNumber(mobile) || timeCode !== defaultTimeCode
                }
                loading={sendLoading}
                onClick={sendSmsUsing}
              >
                {timeCode === defaultTimeCode
                  ? hasCode
                    ? '重新获取验证码'
                    : '获取验证码'
                  : `${timeCode}s`}
              </Button>
            </div>
            {errorMsg && (
              <div className="login-error">
                <img src={require('./error_icon.png')} alt="" />
                <span>{errorMsg}</span>
              </div>
            )}
            <div className="login-button">
              <Button
                disabled={!mobile || !captchaCode}
                className="login-btn"
                onClick={onLogin}
                loading={loading}
              >
                登录
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
